export const useDrag = () => {
        let draggingItem = null
        let initialPosition = { x: 0, y: 0 }

        const getEventCoordinates = event => {
                if (event.type.includes('touch')) {
                        return {
                                clientX: event.touches[0].clientX,
                                clientY: event.touches[0].clientY,
                        }
                }
                return {
                        clientX: event.clientX,
                        clientY: event.clientY,
                }
        }

        const startDrag = (images, item, event, container, scale = 1, onDragEnd = null) => {
                if (!event || !container) return

                event.preventDefault()

                if (!item.locked && !item.isBackground) {
                        draggingItem = item

                        const coords = getEventCoordinates(event)
                        initialPosition = {
                                cursorX: coords.clientX,
                                cursorY: coords.clientY,
                                itemX: item.x,
                                itemY: item.y,
                        }

                        const handleMove = e => {
                                if (!draggingItem) return

                                const coords = getEventCoordinates(e)
                                let deltaX = (coords.clientX - initialPosition.cursorX) / scale
                                let deltaY = (coords.clientY - initialPosition.cursorY) / scale
                                
                                let newX = initialPosition.itemX + deltaX
                                let newY = initialPosition.itemY + deltaY

                                // Убираем ограничения - элементы могут выходить за край рабочей области

                                // Непосредственное обновление координат элемента
                                Object.assign(draggingItem, {
                                        x: newX,
                                        y: newY,
                                })
                        }

                        const endDrag = () => {
                                document.removeEventListener('mousemove', handleMove)
                                document.removeEventListener('touchmove', handleMove)
                                document.removeEventListener('mouseup', endDrag)
                                document.removeEventListener('touchend', endDrag)
                                
                                // Call callback when drag ends
                                if (onDragEnd && typeof onDragEnd === 'function') {
                                        onDragEnd()
                                }
                                
                                draggingItem = null
                        }

                        // Добавляем обработчики для мыши и touch
                        document.addEventListener('mousemove', handleMove)
                        document.addEventListener('touchmove', handleMove, { passive: false })
                        document.addEventListener('mouseup', endDrag)
                        document.addEventListener('touchend', endDrag)
                }
        }

        return { startDrag }
}

export const useGroupDrag = () => {
        let draggingGroup = null
        let initial = {
                cursorX: 0,
                cursorY: 0,
                deltaX: 0,
                deltaY: 0,
        }

        const getEventCoordinates = event => {
                if (event.type.includes('touch')) {
                        return {
                                clientX: event.touches[0].clientX,
                                clientY: event.touches[0].clientY,
                        }
                }
                return {
                        clientX: event.clientX,
                        clientY: event.clientY,
                }
        }

        const startGroupDrag = (group, event, containerEl, scale = 1, onDragEnd = null) => {
                if (!group || group.locked || !event || !containerEl) return

                event.preventDefault()

                draggingGroup = group

                const coords = getEventCoordinates(event)
                initial = {
                        cursorX: coords.clientX,
                        cursorY: coords.clientY,
                        // НОВЫЙ ПОДХОД: используем deltaX/deltaY вместо x/y
                        deltaX: group.deltaX || 0,
                        deltaY: group.deltaY || 0,
                }

                const onMove = e => {
                        if (!draggingGroup) return

                        const coords = getEventCoordinates(e)
                        const rawDeltaX = (coords.clientX - initial.cursorX) / scale
                        const rawDeltaY = (coords.clientY - initial.cursorY) / scale

                        // Обновляем смещение группы
                        draggingGroup.deltaX = initial.deltaX + rawDeltaX
                        draggingGroup.deltaY = initial.deltaY + rawDeltaY
                }

                const onEnd = () => {
                        document.removeEventListener('mousemove', onMove)
                        document.removeEventListener('touchmove', onMove)
                        document.removeEventListener('mouseup', onEnd)
                        document.removeEventListener('touchend', onEnd)
                        
                        // Call callback when drag ends
                        if (onDragEnd && typeof onDragEnd === 'function') {
                                onDragEnd()
                        }
                        
                        draggingGroup = null
                }

                document.addEventListener('mousemove', onMove)
                document.addEventListener('touchmove', onMove, { passive: false })
                document.addEventListener('mouseup', onEnd)
                document.addEventListener('touchend', onEnd)
        }

        return { startGroupDrag }
}
